import React, { createContext, useContext, useState, useRef, useCallback } from 'react';
import ToastNotification from './index';
import './toast-stack.css';

interface ToastItem { id: number; status: number; message: string; }

interface ToastApi {
  show: (status: number, message: string) => void;
  success: (message: string) => void;
  error: (message: string) => void;
  warning: (message: string) => void;
  info: (message: string) => void;
}

const ToastContext = createContext<ToastApi | undefined>(undefined);

export const useToast = (): ToastApi => {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast deve ser usado dentro de <ToastProvider>');
  return ctx;
};

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [toasts, setToasts] = useState<ToastItem[]>([]);
  const idRef = useRef(0);

  const remove = useCallback((id: number) => setToasts(t => t.filter(x => x.id !== id)), []);

  const show = useCallback((status: number, message: string) => {
    idRef.current += 1;
    const id = idRef.current;
    setToasts(t => [...t, { id, status, message }]);
  }, []);

  const api: ToastApi = {
    show,
    success: (m) => show(200, m),
    error: (m) => show(500, m),
    warning: (m) => show(400, m),
    info: (m) => show(0, m),
  };

  return (
    <ToastContext.Provider value={api}>
      {children}
      <div className="app-toast-stack">
        {toasts.map(t => (
          <ToastNotification key={t.id} status={t.status} message={t.message} onClose={() => remove(t.id)} />
        ))}
      </div>
    </ToastContext.Provider>
  );
};
